"use client";
import { useCallback, useMemo, useState } from "react";
import Modal from "../../theme/components/Modal";
import Image from "next/image";

const useProductImageModal = (productTitle) => {
  const [image, setShowImageModal] = useState(null);

  const showImage = useCallback((media) => setShowImageModal(media), []);
  const hideImageModal = useCallback(() => setShowImageModal(null), []);
  const ProductImageModal = useMemo(
    () =>
      image ? (
        <Modal open={image} wide onClose={hideImageModal} title={productTitle}>
          <Image
            src={image.file.url}
            className="force-position-relative"
            alt={image?.texts?.title || productTitle || image?._id}
            fill
            sizes="100vw"
            style={{
              objectFit: "contain",
            }}
          />
        </Modal>
      ) : null,
    [image, hideImageModal],
  );

  return {
    showImage,
    ProductImageModal,
  };
};

export default useProductImageModal;
